import { Component } from '@angular/core';
import { APP_USER_PERMISSIONS } from 'src/app/constants/app-user-permissions.constants';

/**
 * FAQ Component
 */
@Component({
	selector: 'app-faq',
	templateUrl: './faq.component.html',
	styleUrls: ['./faq.component.scss'],
})
export class FaqComponent {
	MODULE_LEVEL = APP_USER_PERMISSIONS;
	/**
	 */
	constructor() {}
}
